import { Link } from "react-router";
import styled from "styled-components";

import Fill from "../components/Fill";
import { useIsStaff } from "../infrastructure/auth0/Auth0ProviderWithNavigate";

const Styled = styled.div`
    display: flex;
    flex-direction: column;
    font-family: sans-serif;
    gap: 16vh;
    height: 100vh;

    header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 24px 128px;
        position: fixed;
        z-index: 999;

        span {
            cursor: default;
            font-size: 1.8rem;
            font-weight: bold;
            text-transform: uppercase;
        }
    }

    a {
        color: transparent;
        display: block;
        font-size: 3.6rem;
        font-weight: bold;
        text-decoration: none;
        position: relative;
        letter-spacing: -2px;
        -webkit-text-stroke: 1px #000;
        margin-top: -21px;

        @supports (-moz-appearance: none) {
            margin-top: -13px;
        }

        &:hover {
            color: #000;
            z-index: 1;
        }

        &::before {
            content: attr(data-abbr);
            font-size: .8rem;
            user-select: none;
            letter-spacing: 0;
            -webkit-text-stroke: initial;
            color: #000;
            position: absolute;
            top: 17px;
            right: 100%;
        }
    }

    .x {
        align-items: flex-end;
        display: flex;
        flex: auto;
        flex-direction: column;
        justify-content: center;
        padding: 0 8px 0;
        position: relative;
    }

    article {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 400px;
        background: #fd0;
        z-index: -1;
    }

    ${ Fill } {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
`;

function Protected(props) {
    const isStaff = useIsStaff();
    return isStaff ? props.children : undefined;
}

export default function Start() {
    return (
        <Styled>
            <Fill />
            <header>
                <span>CONSOLE</span>
            </header>
            <div className="x">
                <Protected><a data-abbr="al" href="https://archicadlocalizer.console.bimproject.cloud">archicad localizer</a></Protected>
                <Protected><a data-abbr="ff" href="https://unleash.bimproject.cloud">feature flags</a></Protected>
                <Protected><Link data-abbr="gp" to="/gdl-parameters">gdl parameters</Link></Protected>
                <Protected><Link data-abbr="bb" to="/io-bundle">io-bundle</Link></Protected>
                <Protected><Link data-abbr="ot" to="/object-template-library">object template library</Link></Protected>
                <Protected><Link data-abbr="ap" to="/applications">applications</Link></Protected>
                <Protected><Link data-abbr="br" to="/brands">brands</Link></Protected>
                <Link data-abbr="de" to="/document-exports">document exports</Link>
                <Link data-abbr="pl" to="/product-lines">product lines</Link>
                <Link data-abbr="pc" to="/pricelists">pricelists</Link>
                <Link data-abbr="pr" to="/products">products</Link>
                <Protected><Link data-abbr="io" to="/product-io">product io</Link></Protected>
                <Protected><Link data-abbr="rf" to="/revit-families">revit families</Link></Protected>
                <Protected><Link data-abbr="rp" to="/revit-parameters">revit parameters</Link></Protected>
                <Protected><Link data-abbr="tx" to="/taxonomy">taxonomy</Link></Protected>
            </div>
        </Styled>
    );
}
